<!-- registerInfo  考试名称报名详情-->
<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="待审核界面" name="unPassedExam">
        <unPassedExam  ref="unPassedExam" :infoId="infoId"  />
      </el-tab-pane>
      <el-tab-pane label="通过审核界面" name="passedExam">
        <passedExam ref="passedExam" :infoId="infoId" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import passedExam from "./passedExam";
import unPassedExam from "./unPassedExam";
export default {
  components: {
    passedExam,
    unPassedExam,
  },
  mounted(){
    let navList= this.$store.state.websetting.navBreadList;
    navList[2].title=this.$route.query.name + "报名详情";
    this.$store.commit("setNav",navList);
  },
  created() {
     if (!this.$route.query.id || !this.$route.query.name) {
      this.$router.go(-1);
      this.$message({ type: "warning", message: "id已过期,请重新查看!" ,duration:1000});
      return;
    }
    this.infoId = this.$route.query.id;
  },
  watch:{
    activeName(val){
      console.log(val);
      this.$refs[val].tableLoad()
    }
  },
  data() {
    return {
      infoId: null,
      activeName: "unPassedExam",
    };
  },
};
</script>